import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { api_getContentPageByCode, api_getContentPageByUrl } from '~/backend/api_calls';
import PageHeaderMeta from '~/components/common/PageHeaderMeta';
import Sidebar from '~/components/content/Sidebar';

export default function ContentPage() {
	const navigate = useNavigate();
	const { t, i18n } = useTranslation();
	let { eurl } = useParams();
	const [contentPage, setContentPage] = useState({});
	const [sidebarPages, setSidebarPages] = useState({});

	const [productReturn, setProductReturn] = useState('');
	const [moneyReturn, setMoneyReturn] = useState('');
	const [defProduct, setDefProduct] = useState('');
	const [cancelOrder, setCancelOrder] = useState('');

	// Runs once after init rendering + if eurl changes
	useEffect(() => {
		if (eurl === 'contact') {
			navigate('/contact');
			return;
		} else if (eurl === 'stores') {
			navigate('/storefinder');
			return;
		} else if (eurl === 'blog') {
			navigate('/blog');
			return;
		} else if (eurl === 'b2b') {
			window.location = 'https://b2b.bodytalk.com/';
			return;
		} else if (eurl === 'jobs') {
			window.location = 'https://bodytalkcorp.com/jobs/';
			return;
		}

		api_getContentPageByUrl(eurl)
			.then(json => {
				setContentPage(json);
				closeMenuContent();
			})
			.catch(error => {
				console.log(error);
				navigate('/');
			});

		api_getContentPageByCode('product_return').then(json => setProductReturn(json));

		api_getContentPageByCode('return_money').then(json => setMoneyReturn(json));

		api_getContentPageByCode('defective_product').then(json => setDefProduct(json));

		api_getContentPageByCode('cancel_order').then(json => setCancelOrder(json));
	}, [eurl]);

	const showContent = event => {
		var container = window.document.getElementsByClassName('main-content')[0];
		container.classList.add('clicked');
		var currentid = event.currentTarget.id;
		window.document.getElementsByClassName(currentid)[0].style.display = 'block';
	};

	const closeContent = event => {
		var container = window.document.getElementsByClassName('main-content')[0];
		container.classList.remove('clicked');
		const contents = document.getElementsByClassName('clicked-content');
		for (const content of contents) {
			content.style.display = 'none';
		}
	};

	const closeMenuContent = () => {
		var modal = window.document.getElementById('menu-modal');
		var header = window.document.getElementsByTagName('header')[0];
		var mobile_account = window.document.querySelector('.login-register-mobile');

		if (modal.classList.contains('show')) {
			modal.style.opacity = '0';
			modal.style.pointerEvents = 'none';
			modal.classList.remove('show');
			header.classList.remove('line-header');
			mobile_account.classList.remove('active');
			window.document.getElementById('burger-btn').classList.remove('active');
		}
	};

	return (
		<>
			<PageHeaderMeta page_title={contentPage.tl} meta_keywords={contentPage.mk} meta_description={contentPage.md} />

			<div id="info-page" className="main-wrapper">
				{contentPage.ssb ? (
					<div className="content-wrapper">
						<Sidebar pageName={contentPage.tl} pageurl={contentPage.eurl} />

						{contentPage.cd == 'return-policy' && (
							<main className={contentPage.cd == 'return-policy' ? 'main-content return-policy' : 'main-content'}>
								<div className="content-wrapper back-section">
									<button id="back-to" onClick={closeContent}>
										<span>
											<svg xmlns="http://www.w3.org/2000/svg" width="18.75" height="12.69" viewBox="0 0 18.75 12.69">
												<g
													id="Icon_feather-arrow-right"
													data-name="Icon feather-arrow-right"
													transform="translate(18.75 12.159) rotate(180)">
													<path
														id="Path_38024"
														data-name="Path 38024"
														d="M7.5,18h18"
														transform="translate(-7.5 -12.185)"
														fill="none"
														stroke="#000"
														strokeLinejoin="round"
														strokeWidth="1.5"
													/>
													<path
														id="Path_38025"
														data-name="Path 38025"
														d="M18,7.5l5.815,5.815L18,19.129"
														transform="translate(-5.815 -7.5)"
														fill="none"
														stroke="#000"
														strokeLinejoin="round"
														strokeWidth="1.5"
													/>
												</g>
											</svg>
										</span>
										{t('back')}
									</button>
								</div>

								<div className="content-wrapper">
									<h1 className="page-heading page-title">{contentPage.tl}</h1>
								</div>

								<div className="content-wrapper cms-content">
									<div className="hide-content">
										{/* <p>{t("return_policy_page_summary")}</p>*/}
										<span
											dangerouslySetInnerHTML={{
												__html: contentPage.bd
											}}></span>
									</div>

									<div className="content-buttons">
										<div className="button" id="content-1" onClick={showContent}>
											<div className="image-container">
												<svg xmlns="http://www.w3.org/2000/svg" width="68.65" height="36.633" viewBox="0 0 68.65 36.633">
													<g id="Group_174042" data-name="Group 174042" transform="translate(-1060.999 -211.367)">
														<path
															id="undo_FILL0_wght400_GRAD0_opsz48"
															d="M21.164,27.358H11.872V25.423H21.2a5.543,5.543,0,0,0,3.888-1.5,5.076,5.076,0,0,0,0-7.453,5.543,5.543,0,0,0-3.888-1.5H11.678l3.678,3.678L14,20,8,14l6-6,1.355,1.355-3.678,3.678h9.486A7.46,7.46,0,0,1,26.439,15.1a6.7,6.7,0,0,1,2.21,5.1,6.7,6.7,0,0,1-2.21,5.1A7.46,7.46,0,0,1,21.164,27.358Z"
															transform="translate(1101 203.367)"
														/>
														<path
															id="undo_FILL0_wght400_GRAD0_opsz48-2"
															data-name="undo_FILL0_wght400_GRAD0_opsz48"
															d="M21.164,27.358H11.872V25.423H21.2a5.543,5.543,0,0,0,3.888-1.5,5.076,5.076,0,0,0,0-7.453,5.543,5.543,0,0,0-3.888-1.5H11.678l3.678,3.678L14,20,8,14l6-6,1.355,1.355-3.678,3.678h9.486A7.46,7.46,0,0,1,26.439,15.1a6.7,6.7,0,0,1,2.21,5.1,6.7,6.7,0,0,1-2.21,5.1A7.46,7.46,0,0,1,21.164,27.358Z"
															transform="translate(1089.648 256) rotate(180)"
														/>
														<path
															id="Icon_awesome-tshirt"
															data-name="Icon awesome-tshirt"
															d="M28.59,4.371,19.77,0a6.573,6.573,0,0,1-5.277,2.138A6.573,6.573,0,0,1,9.216,0L.4,4.371a.73.73,0,0,0-.326.974l2.591,5.186a.73.73,0,0,0,.974.326L6.2,9.6a.723.723,0,0,1,1.042.652V21.742a1.448,1.448,0,0,0,1.449,1.449h11.6a1.448,1.448,0,0,0,1.449-1.449V10.251A.725.725,0,0,1,22.778,9.6l2.564,1.255a.722.722,0,0,0,.974-.326l2.6-5.182a.723.723,0,0,0-.322-.974Z"
															transform="translate(1080.504 221.046)"
															fill="none"
															stroke="#ababab"
															strokeWidth="2"
														/>
													</g>
												</svg>
											</div>
											<div className="title">{productReturn.tl}</div>
										</div>

										<div className="button" id="content-2" onClick={showContent}>
											<div className="image-container">
												<svg xmlns="http://www.w3.org/2000/svg" width="38.306" height="37.438" viewBox="0 0 38.306 37.438">
													<g id="Group_1448" data-name="Group 1448" transform="translate(-49.724 -290.037)">
														<path
															id="Path_3978"
															data-name="Path 3978"
															d="M81.056,315.443c.336-1.55.722-2.869.722-2.869l-3.232-3.754-4.483-1.595-1.113.334-3.85,2.174a4.49,4.49,0,0,0,.472,2.541c1.658,2.056,5.29,2.43,6.343,3.43A6.828,6.828,0,0,1,78,320.152c-.034,1.318-2.094,1.624-3.282,1.095-.7-.311-6.668-2.309-10.454-3.623A10.609,10.609,0,0,1,59,313.6c-2.368-3.442-5.223-8.224-5.223-8.224L50,304.3"
															transform="translate(0 -2.065)"
															fill="none"
															stroke="#ababab"
															strokeLinejoin="round"
															strokeWidth="2"
														/>
														<path
															id="Path_3979"
															data-name="Path 3979"
															d="M54,291s16.718,4.7,23.689,6.634a7.01,7.01,0,0,1,3.885,2.755l6.076,8.726-2.333,7.453"
															transform="translate(-0.621 0)"
															fill="none"
															stroke="#ababab"
															strokeLinejoin="round"
															strokeWidth="2"
														/>
														<path
															id="Path_3980"
															data-name="Path 3980"
															d="M79.928,317.619a6.749,6.749,0,1,1-3.768,4.672"
															transform="translate(-4.039 -4.039)"
															fill="none"
															stroke="#000"
															strokeLinejoin="round"
															strokeWidth="2"
														/>
													</g>
												</svg>
											</div>
											<div className="title">{moneyReturn.tl}</div>
										</div>

										<div className="button" id="content-3" onClick={showContent}>
											<div className="image-container">
												<svg xmlns="http://www.w3.org/2000/svg" width="40.369" height="32.893" viewBox="0 0 40.369 32.893">
													<g id="Group_174054" data-name="Group 174054" transform="translate(-554.418 -272.774)">
														<path
															id="Icon_awesome-tshirt"
															data-name="Icon awesome-tshirt"
															d="M37.75,5.771,26.105,0c-1.2,1.663-3.864,2.823-6.968,2.823S13.372,1.663,12.17,0L.526,5.771A.964.964,0,0,0,.1,7.057l3.421,6.848a.964.964,0,0,0,1.286.431l3.385-1.657a.955.955,0,0,1,1.376.861V28.708a1.912,1.912,0,0,0,1.914,1.914H26.787A1.912,1.912,0,0,0,28.7,28.708V13.535a.957.957,0,0,1,1.376-.861l3.385,1.657a.954.954,0,0,0,1.286-.431l3.427-6.842a.955.955,0,0,0-.425-1.286Z"
															transform="translate(555.504 274.046)"
															fill="none"
															stroke="#ababab"
															strokeWidth="2"
														/>
														<path
															id="Path_38270"
															data-name="Path 38270"
															d="M-23955.527,447.691l-3.447-6.179,3.447-4.158-3.447-3.9"
															transform="translate(24534.975 -143.024)"
															fill="none"
															stroke="#000"
															strokeWidth="2"
														/>
													</g>
												</svg>
											</div>
											<div className="title">{defProduct.tl}</div>
										</div>

										<div className="button" id="content-4" onClick={showContent}>
											<div className="image-container">
												<svg xmlns="http://www.w3.org/2000/svg" width="42.012" height="41.523" viewBox="0 0 42.012 41.523">
													<g id="Group_174050" data-name="Group 174050" transform="translate(-950.899 -464.086)">
														<path
															id="Path_38269"
															data-name="Path 38269"
															d="M41.49,71.124a1.444,1.444,0,0,0-1.152-.575H34.71a.889.889,0,1,0,0,1.778h5.223L35.4,87.022H12.728L8.836,72.327h5.395a.889.889,0,1,0,0-1.778H8.309L7.174,66.293l-.007-.021a1.494,1.494,0,0,0-1.444-1.041l-4.852.091A.889.889,0,0,0,0,66.227a.892.892,0,0,0,.892.872H.905l4.621-.087L12.14,91.819l.007.021a1.5,1.5,0,0,0,1.417,1.041h.019l20.512-.046a.889.889,0,0,0,0-1.778l-20.3.046-.614-2.3H35.636a1.48,1.48,0,0,0,1.408-1.086l4.7-15.22.009-.03a1.55,1.55,0,0,0-.261-1.339"
															transform="translate(951 403.321)"
															fill="#ababab"
															stroke="#ababab"
															strokeWidth="0.2"
														/>
														<circle
															id="Ellipse_9238"
															data-name="Ellipse 9238"
															cx="2.35"
															cy="2.35"
															r="2.35"
															transform="translate(976.994 500.872) rotate(-45)"
															fill="none"
															stroke="#ababab"
															strokeMiterlimit="10"
															strokeWidth="2"
														/>
														<ellipse
															id="Ellipse_9239"
															data-name="Ellipse 9239"
															cx="2.35"
															cy="2.35"
															rx="2.35"
															ry="2.35"
															transform="translate(965.793 499.104) rotate(-12.855)"
															fill="none"
															stroke="#ababab"
															strokeMiterlimit="10"
															strokeWidth="2"
														/>
														<circle
															id="Ellipse_9240"
															data-name="Ellipse 9240"
															cx="6.547"
															cy="6.547"
															r="6.547"
															transform="translate(966.207 474.759) rotate(-45)"
															fill="none"
															stroke="#000"
															strokeMiterlimit="10"
															strokeWidth="2"
														/>
														<g id="Group_174049" data-name="Group 174049" transform="translate(972.578 471.871)">
															<line id="Line_488" data-name="Line 488" x2="5.776" y2="5.776" fill="none" stroke="#000" strokeWidth="2" />
															<line id="Line_489" data-name="Line 489" x1="5.776" y2="5.776" fill="none" stroke="#000" strokeWidth="2" />
														</g>
													</g>
												</svg>
											</div>
											<div className="title">{cancelOrder.tl}</div>
										</div>
									</div>

									<div className="clicked-content content-1">
										<div className="content-wrapper">
											<div className="image-container">
												<svg xmlns="http://www.w3.org/2000/svg" width="68.65" height="36.633" viewBox="0 0 68.65 36.633">
													<g id="Group_174042" data-name="Group 174042" transform="translate(-1060.999 -211.367)">
														<path
															id="undo_FILL0_wght400_GRAD0_opsz48"
															d="M21.164,27.358H11.872V25.423H21.2a5.543,5.543,0,0,0,3.888-1.5,5.076,5.076,0,0,0,0-7.453,5.543,5.543,0,0,0-3.888-1.5H11.678l3.678,3.678L14,20,8,14l6-6,1.355,1.355-3.678,3.678h9.486A7.46,7.46,0,0,1,26.439,15.1a6.7,6.7,0,0,1,2.21,5.1,6.7,6.7,0,0,1-2.21,5.1A7.46,7.46,0,0,1,21.164,27.358Z"
															transform="translate(1101 203.367)"
														/>
														<path
															id="undo_FILL0_wght400_GRAD0_opsz48-2"
															data-name="undo_FILL0_wght400_GRAD0_opsz48"
															d="M21.164,27.358H11.872V25.423H21.2a5.543,5.543,0,0,0,3.888-1.5,5.076,5.076,0,0,0,0-7.453,5.543,5.543,0,0,0-3.888-1.5H11.678l3.678,3.678L14,20,8,14l6-6,1.355,1.355-3.678,3.678h9.486A7.46,7.46,0,0,1,26.439,15.1a6.7,6.7,0,0,1,2.21,5.1,6.7,6.7,0,0,1-2.21,5.1A7.46,7.46,0,0,1,21.164,27.358Z"
															transform="translate(1089.648 256) rotate(180)"
														/>
														<path
															id="Icon_awesome-tshirt"
															data-name="Icon awesome-tshirt"
															d="M28.59,4.371,19.77,0a6.573,6.573,0,0,1-5.277,2.138A6.573,6.573,0,0,1,9.216,0L.4,4.371a.73.73,0,0,0-.326.974l2.591,5.186a.73.73,0,0,0,.974.326L6.2,9.6a.723.723,0,0,1,1.042.652V21.742a1.448,1.448,0,0,0,1.449,1.449h11.6a1.448,1.448,0,0,0,1.449-1.449V10.251A.725.725,0,0,1,22.778,9.6l2.564,1.255a.722.722,0,0,0,.974-.326l2.6-5.182a.723.723,0,0,0-.322-.974Z"
															transform="translate(1080.504 221.046)"
															fill="none"
															stroke="#ababab"
															strokeWidth="2"
														/>
													</g>
												</svg>
											</div>
											<h3 className="page-heading page-title">{productReturn.tl}</h3>
											{/*                             <p>{t("return_policy_page_title_first_summary")}*/}
											{/*                                 <strong>{t("return_policy_page_step1")}</strong>*/}
											{/*                                 {t("return_policy_page_title_first_content1")}*/}
											{/*                                 <strong>{t("return_policy_page_step2")}</strong>*/}
											{/*                                 {t("return_policy_page_title_first_content2")}*/}
											{/*</p>*/}
											<span
												dangerouslySetInnerHTML={{
													__html: productReturn.bd
												}}></span>
										</div>
									</div>
									<div className="clicked-content content-2">
										<div className="content-wrapper">
											<div className="image-container">
												<svg xmlns="http://www.w3.org/2000/svg" width="38.306" height="37.438" viewBox="0 0 38.306 37.438">
													<g id="Group_1448" data-name="Group 1448" transform="translate(-49.724 -290.037)">
														<path
															id="Path_3978"
															data-name="Path 3978"
															d="M81.056,315.443c.336-1.55.722-2.869.722-2.869l-3.232-3.754-4.483-1.595-1.113.334-3.85,2.174a4.49,4.49,0,0,0,.472,2.541c1.658,2.056,5.29,2.43,6.343,3.43A6.828,6.828,0,0,1,78,320.152c-.034,1.318-2.094,1.624-3.282,1.095-.7-.311-6.668-2.309-10.454-3.623A10.609,10.609,0,0,1,59,313.6c-2.368-3.442-5.223-8.224-5.223-8.224L50,304.3"
															transform="translate(0 -2.065)"
															fill="none"
															stroke="#ababab"
															strokeLinejoin="round"
															strokeWidth="2"
														/>
														<path
															id="Path_3979"
															data-name="Path 3979"
															d="M54,291s16.718,4.7,23.689,6.634a7.01,7.01,0,0,1,3.885,2.755l6.076,8.726-2.333,7.453"
															transform="translate(-0.621 0)"
															fill="none"
															stroke="#ababab"
															strokeLinejoin="round"
															strokeWidth="2"
														/>
														<path
															id="Path_3980"
															data-name="Path 3980"
															d="M79.928,317.619a6.749,6.749,0,1,1-3.768,4.672"
															transform="translate(-4.039 -4.039)"
															fill="none"
															stroke="#000"
															strokeLinejoin="round"
															strokeWidth="2"
														/>
													</g>
												</svg>
											</div>
											<h3 className="page-heading page-title">{moneyReturn.tl}</h3>
											{/*                                <p>{t("return_policy_page_title_second_summary")}*/}
											{/*                                    <strong>{t("return_policy_page_step1")}</strong>*/}
											{/*                                    {t("return_policy_page_title_second_content1")}*/}
											{/*                                    <strong>{t("return_policy_page_step2")}</strong>*/}
											{/*                                    {t("return_policy_page_title_second_content2")}*/}
											{/*</p>*/}
											<span
												dangerouslySetInnerHTML={{
													__html: moneyReturn.bd
												}}></span>
										</div>
									</div>
									<div className="clicked-content content-3">
										<div className="content-wrapper">
											<div className="image-container">
												<svg xmlns="http://www.w3.org/2000/svg" width="40.369" height="32.893" viewBox="0 0 40.369 32.893">
													<g id="Group_174054" data-name="Group 174054" transform="translate(-554.418 -272.774)">
														<path
															id="Icon_awesome-tshirt"
															data-name="Icon awesome-tshirt"
															d="M37.75,5.771,26.105,0c-1.2,1.663-3.864,2.823-6.968,2.823S13.372,1.663,12.17,0L.526,5.771A.964.964,0,0,0,.1,7.057l3.421,6.848a.964.964,0,0,0,1.286.431l3.385-1.657a.955.955,0,0,1,1.376.861V28.708a1.912,1.912,0,0,0,1.914,1.914H26.787A1.912,1.912,0,0,0,28.7,28.708V13.535a.957.957,0,0,1,1.376-.861l3.385,1.657a.954.954,0,0,0,1.286-.431l3.427-6.842a.955.955,0,0,0-.425-1.286Z"
															transform="translate(555.504 274.046)"
															fill="none"
															stroke="#ababab"
															strokeWidth="2"
														/>
														<path
															id="Path_38270"
															data-name="Path 38270"
															d="M-23955.527,447.691l-3.447-6.179,3.447-4.158-3.447-3.9"
															transform="translate(24534.975 -143.024)"
															fill="none"
															stroke="#000"
															strokeWidth="2"
														/>
													</g>
												</svg>
											</div>
											<h3 className="page-heading page-title">{defProduct.tl}</h3>
											{/*<p>{t("return_policy_page_title_third_summary")}*/}
											{/*    <strong>{t("return_policy_page_step1")}</strong>*/}
											{/*    {t("return_policy_page_title_third_content1")}*/}
											{/*    <strong>{t("return_policy_page_step2")}</strong>*/}
											{/*    {t("return_policy_page_title_third_content2")}*/}
											{/*</p>*/}
											<span
												dangerouslySetInnerHTML={{
													__html: defProduct.bd
												}}></span>
										</div>
									</div>
									<div className="clicked-content content-4">
										<div className="content-wrapper">
											<div className="image-container">
												<svg xmlns="http://www.w3.org/2000/svg" width="42.012" height="41.523" viewBox="0 0 42.012 41.523">
													<g id="Group_174050" data-name="Group 174050" transform="translate(-950.899 -464.086)">
														<path
															id="Path_38269"
															data-name="Path 38269"
															d="M41.49,71.124a1.444,1.444,0,0,0-1.152-.575H34.71a.889.889,0,1,0,0,1.778h5.223L35.4,87.022H12.728L8.836,72.327h5.395a.889.889,0,1,0,0-1.778H8.309L7.174,66.293l-.007-.021a1.494,1.494,0,0,0-1.444-1.041l-4.852.091A.889.889,0,0,0,0,66.227a.892.892,0,0,0,.892.872H.905l4.621-.087L12.14,91.819l.007.021a1.5,1.5,0,0,0,1.417,1.041h.019l20.512-.046a.889.889,0,0,0,0-1.778l-20.3.046-.614-2.3H35.636a1.48,1.48,0,0,0,1.408-1.086l4.7-15.22.009-.03a1.55,1.55,0,0,0-.261-1.339"
															transform="translate(951 403.321)"
															fill="#ababab"
															stroke="#ababab"
															strokeWidth="0.2"
														/>
														<circle
															id="Ellipse_9238"
															data-name="Ellipse 9238"
															cx="2.35"
															cy="2.35"
															r="2.35"
															transform="translate(976.994 500.872) rotate(-45)"
															fill="none"
															stroke="#ababab"
															strokeMiterlimit="10"
															strokeWidth="2"
														/>
														<ellipse
															id="Ellipse_9239"
															data-name="Ellipse 9239"
															cx="2.35"
															cy="2.35"
															rx="2.35"
															ry="2.35"
															transform="translate(965.793 499.104) rotate(-12.855)"
															fill="none"
															stroke="#ababab"
															strokeMiterlimit="10"
															strokeWidth="2"
														/>
														<circle
															id="Ellipse_9240"
															data-name="Ellipse 9240"
															cx="6.547"
															cy="6.547"
															r="6.547"
															transform="translate(966.207 474.759) rotate(-45)"
															fill="none"
															stroke="#000"
															strokeMiterlimit="10"
															strokeWidth="2"
														/>
														<g id="Group_174049" data-name="Group 174049" transform="translate(972.578 471.871)">
															<line id="Line_488" data-name="Line 488" x2="5.776" y2="5.776" fill="none" stroke="#000" strokeWidth="2" />
															<line id="Line_489" data-name="Line 489" x1="5.776" y2="5.776" fill="none" stroke="#000" strokeWidth="2" />
														</g>
													</g>
												</svg>
											</div>
											<h3 className="page-heading page-title">{cancelOrder.tl}</h3>
											{/*                                <p>{t("return_policy_page_title_third_summary")}*/}
											{/*                                    <strong>{t("return_policy_page_step1")}</strong>*/}
											{/*                                    {t("return_policy_page_title_third_content1")}*/}
											{/*                                    <strong>{t("return_policy_page_step2")}</strong>*/}
											{/*                                    {t("return_policy_page_title_third_content2")}*/}
											{/*</p>*/}
											<span
												dangerouslySetInnerHTML={{
													__html: cancelOrder.bd
												}}></span>
										</div>
									</div>
								</div>

								<div className="contact-section">
									<div className="content-wrapper">
										<p>{t('return_policy_page_contact')}</p>
										<div className="half-part first">
											<span>
												<svg
													id="Group_173934"
													data-name="Group 173934"
													xmlns="http://www.w3.org/2000/svg"
													width="22"
													height="22"
													viewBox="0 0 22 22">
													<rect id="Rectangle_161337" data-name="Rectangle 161337" width="22" height="22" fill="none" />
													<path
														id="Icon_feather-phone"
														data-name="Icon feather-phone"
														d="M20.817,16.24V18.9a1.775,1.775,0,0,1-1.935,1.775,17.562,17.562,0,0,1-7.658-2.724A17.3,17.3,0,0,1,5.9,12.628,17.562,17.562,0,0,1,3.175,4.934,1.775,1.775,0,0,1,4.941,3H7.6A1.775,1.775,0,0,1,9.378,4.526,11.394,11.394,0,0,0,10,7.02a1.775,1.775,0,0,1-.4,1.872L8.473,10.019A14.2,14.2,0,0,0,13.8,15.344l1.127-1.127a1.775,1.775,0,0,1,1.872-.4,11.394,11.394,0,0,0,2.494.621A1.775,1.775,0,0,1,20.817,16.24Z"
														transform="translate(-0.668 -0.5)"
														fill="none"
														stroke="#000"
														strokeLinecap="round"
														strokeLinejoin="round"
														strokeWidth="1"
													/>
												</svg>
											</span>
											<p className="text">
												{t('call_us')}
												<br />
												<a href="tel:00302103400100">(+30) 210 3400100</a>
											</p>
										</div>
										<div className="half-part">
											<span>
												<svg xmlns="http://www.w3.org/2000/svg" width="18.136" height="14.395" viewBox="0 0 18.136 14.395">
													<g id="Icon_feather-mail" data-name="Icon feather-mail" transform="translate(0.696 0.5)">
														<path
															id="Path_38257"
															data-name="Path 38257"
															d="M4.674,6H18.069a1.679,1.679,0,0,1,1.674,1.674V17.72a1.679,1.679,0,0,1-1.674,1.674H4.674A1.679,1.679,0,0,1,3,17.72V7.674A1.679,1.679,0,0,1,4.674,6Z"
															transform="translate(-3 -6)"
															fill="none"
															stroke="#000"
															strokeLinecap="round"
															strokeLinejoin="round"
															strokeWidth="1"
														/>
														<path
															id="Path_38258"
															data-name="Path 38258"
															d="M19.743,9l-8.372,5.86L3,9"
															transform="translate(-3 -7.326)"
															fill="none"
															stroke="#000"
															strokeLinecap="round"
															strokeLinejoin="round"
															strokeWidth="1"
														/>
													</g>
												</svg>
											</span>
											<p className="text">
												{t('email_us')}
												<br />
												<a href="mailto:eshop@bodytalk.com">eshop@bodytalk.com</a>
											</p>
										</div>
									</div>
								</div>
							</main>
						)}

						{contentPage.cd !== 'return-policy' && (
							<main className={contentPage.cd == 'return-policy' ? 'main-content return-policy' : 'main-content'}>
								<div className="content-wrapper back-section">
									<button id="back-to" onClick={closeContent}>
										<span>
											<svg xmlns="http://www.w3.org/2000/svg" width="18.75" height="12.69" viewBox="0 0 18.75 12.69">
												<g
													id="Icon_feather-arrow-right"
													data-name="Icon feather-arrow-right"
													transform="translate(18.75 12.159) rotate(180)">
													<path
														id="Path_38024"
														data-name="Path 38024"
														d="M7.5,18h18"
														transform="translate(-7.5 -12.185)"
														fill="none"
														stroke="#000"
														strokeLinejoin="round"
														strokeWidth="1.5"
													/>
													<path
														id="Path_38025"
														data-name="Path 38025"
														d="M18,7.5l5.815,5.815L18,19.129"
														transform="translate(-5.815 -7.5)"
														fill="none"
														stroke="#000"
														strokeLinejoin="round"
														strokeWidth="1.5"
													/>
												</g>
											</svg>
										</span>
										{t('back')}
									</button>
								</div>

								<div className="content-wrapper">
									<h1 className="page-heading page-title">{contentPage.tl}</h1>
								</div>

								<div
									className="content-wrapper cms-content"
									dangerouslySetInnerHTML={{
										__html: contentPage.bd
									}}></div>
							</main>
						)}
					</div>
				) : (
					<div className="content-wrapper simple-page">
						<div className="content-wrapper">
							<div
								className="cms-content"
								dangerouslySetInnerHTML={{
									__html: contentPage.bd
								}}></div>
						</div>
					</div>
				)}
			</div>
		</>
	);
}
